import { __extends, __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { Toolbar } from './toolbar.esm.js';
import styles from './uitk-toolbar.css';
var getClassNameList = classNames.bind(styles);
var UitkTransparentToolbar = /** @class */function (_super) {
  __extends(UitkTransparentToolbar, _super);
  function UitkTransparentToolbar() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  UitkTransparentToolbar.prototype.render = function () {
    var _a = this.props,
      overlay = _a.overlay,
      className = _a.className,
      props = __rest(_a, ["overlay", "className"]);
    var wrapperClassNames = getClassNameList(overlay && "".concat(Toolbar.baseClassName, "-transparent-overlay"), className);
    return React.createElement(Toolbar, __assign({
      className: wrapperClassNames
    }, props, {
      toolbarType: "transparent"
    }));
  };
  UitkTransparentToolbar.displayName = 'UitkTransparentToolbar';
  return UitkTransparentToolbar;
}(React.Component);
export { UitkTransparentToolbar };